import { createStore, applyMiddleware } from "redux"
import reducers from "./reducers/index"
import thunk from "redux-thunk"
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist"
import persistStore from "redux-persist/es/persistStore";
import { composeWithDevTools } from 'redux-devtools-extension';

const persistConfig = {
    key: 'root',
    storage
}

const persistetReducer = persistReducer(persistConfig, reducers)

export const store = createStore(
    persistetReducer,
    composeWithDevTools(applyMiddleware(thunk)),
)

export const persitor = persistStore(store)